<template>
  <div class="container" fluid>
    <b-modal
      scrollable
      id="createRss"
      @cancel="resetFields"
      @ok="createUrlSouce"
      size="xl"
      title="Create RSS Source"
    >
      <div class="isSimple" v-if="isSimple">
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Reference:</label>
              </b-col>
              <b-col sm="10">
                <b-form-input
                  size="sm"
                  placeholder="Enter the reference source"
                  v-model="SourceRss.c_u_ReferenceSource"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Status:</label>
              </b-col>
              <b-col sm="6">
                <b-form-select
                  :options="statusOptions"
                  v-model="SourceRss.c_u_Status"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Regularity:</label>
              </b-col>
              <b-col sm="6">
                <b-form-select
                  :options="regularityOptions"
                  v-model="SourceRss.c_u_Regularity"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of clicked">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>Url:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the url"
                    v-model="urlArray[item - 1].url"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Priority:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="urlArray[item - 1].priority"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other url'"
              @click="addUrlDiv(clicked)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">Query XPATH:</label>
              </b-col>
              <b-col>
                <b-form-textarea
                  id="textarea"
                  placeholder="Enter the query..."
                  rows="3"
                  v-model="urlParameters1"
                ></b-form-textarea>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11 text-center">
            <b-button variant="outline-primary" size="sm" v-b-modal.modal-rss-2
              >News Configuration</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!--advanced Mode XML1-->
      <div class="isSimple" v-if="isSimple == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="12"
              size="sm"
              v-model="advancedXML"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="advancedMode(isSimple)"
        class="advance"
        >Advanced Mode</b-button
      >
    </b-modal>
    <!--News Configuration Modal-->
    <b-modal
      id="modal-rss-2"
      @cancel="resetFields"
      @ok="createXml2"
      size="lg"
      title="News Configuration"
    >
      <div class="isSimple2" v-if="isSimple2">
        <b-row>
          <b-col style="text-align: center">
            <label>Title</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivTitle">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="titleArray[item - 1].query"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="titleArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other Query'"
              @click="addTitleDiv(addDivTitle)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Resume</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivResume">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="resumeArray[item - 1].query"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="resumeArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other Query'"
              @click="addResumeDiv(addDivResume)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Image</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivImage">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="imageArray[item - 1].query"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="imageArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other Query'"
              @click="addImageDiv(addDivImage)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Text</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivText">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="textArray[item - 1].query"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="confidenceOptions"
                    v-model="textArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other Query'"
              @click="addTextDiv(addDivText)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Remove</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivRemove">
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Reference :</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    :options="removeOptions"
                    v-model="removeArray[item - 1].reference"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="removeArray[item - 1].query"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other Query'"
              @click="addRemoveDiv(addDivRemove)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!--Advanced Mode XML2-->
      <div class="isSimple2" v-if="isSimple2 == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="12"
              size="sm"
              v-model="advancedXML2"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="advancedMode2(isSimple2)"
        class="advance2"
        >Advanced Mode</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "CreateRss",

  data() {
    return {
      clicked: 1,
      addDivTitle: 2,
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      isSimple: true,
      isSimple2: true,
      disabled: true,
      document: $(document),
      urlParameters1: "",
      advancedXML: "",
      advancedXML2: "",
      urlArray: [
        {
          url: "",
          priority: 0,
        },
      ],
      titleArray: [
        {
          query: "//meta[@property='og:title']/@content",
          confidenceLevel: 30,
        },
        {
          query: "//title",
          confidenceLevel: 20,
        },
      ],
      resumeArray: [
        {
          query: "//meta[@property='og:description']/@content",
          confidenceLevel: 30,
        },
      ],
      imageArray: [
        {
          query: "//meta[@property='og:image']/@content",
          confidenceLevel: 30,
        },
      ],
      textArray: [
        {
          query: "",
          confidenceLevel: 0,
        },
      ],
      removeArray: [
        {
          reference: 0,
          query: "",
        },
      ],
      SourceRss: {
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Parameters1: "",
        c_u_Parameters2: "",
      },
      priorityOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      statusOptions: [
        { value: "0", text: "Please select a status" },
        { value: "1", text: "Enabled" },
        { value: "2", text: "Disabled" },
      ],
      regularityOptions: [
        { value: "0", text: "Please select a regularity" },
        { value: "10", text: "10 Minutos" },
        { value: "20", text: "20 Minutos" },
        { value: "30", text: "30 Minutos" },
        { value: "40", text: "40 Minutos" },
        { value: "50", text: "50 Minutos" },
        { value: "60", text: "60 Minutos" },
      ],
      confidenceOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      removeOptions: [
        { value: "0", text: "Please select a Reference" },
        { value: "title", text: "Title" },
        { value: "resume", text: "Resume" },
        { value: "image", text: "Image" },
        { value: "text", text: "Text" },
      ],
    };
  },

  components: {},

  methods: {
    resetFields() {
      this.referenceSource = "";
      this.urlArray = [
        {
          url: "",
          priority: 0,
        },
      ];
      this.clicked = 1;
      this.isSimple = true;
      this.urlParameters1 = "";
    },
    createXml2(evt) {
      const xml = require("xml");
      // structur of the xml for the parameters2
      let xml2 = [
        {
          Configuration: [
            { _attr: { for: "News" } },
            { URLs: "" },
            {
              ToExtract: [
                {
                  Item: [
                    { _attr: { ForURLsID: "", Reference: "title" } },
                    { Queries: [] },
                    { URL: [] },
                  ],
                },
                {
                  Item: [
                    { _attr: { ForURLsID: "", Reference: "resume" } },
                    { Queries: [] },
                    { URL: [] },
                  ],
                },
                {
                  Item: [
                    { _attr: { ForURLsID: "", Reference: "image" } },
                    { Queries: [] },
                    { URL: [] },
                  ],
                },
                {
                  Item: [
                    { _attr: { ForURLsID: "", Reference: "text" } },
                    { Queries: [] },
                    { URL: [] },
                  ],
                },
              ],
            },
            { ToRemove: [] },
          ],
        },
      ];

      //for loop to create the queries of title in the xml
      for (var index = 0; index < this.titleArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
          Query: [
            {
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.titleArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false",
              },
            },
            this.titleArray[index].query,
          ],
        });
      }

      //for loop to create the queries of resume in the xml
      for (var index = 0; index < this.resumeArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
          Query: [
            {
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.resumeArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false",
              },
            },
            this.resumeArray[index].query,
          ],
        });
      }

      //for loop to create the queries of image in the xml
      for (var index = 0; index < this.imageArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
          Query: [
            {
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.imageArray[index].confidenceLevel,
                IsURL: "true",
                IsFullURL: "true",
                ToReplace: "",
                PrepareTextForQS: "false",
              },
            },
            this.imageArray[index].query,
          ],
        });
      }

      //for loop to create the queries of text in the xml
      for (var index = 0; index < this.textArray.length; index++) {
        xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
          Query: [
            {
              _attr: {
                Id: index + 1,
                ConfidenceLevel: this.textArray[index].confidenceLevel,
                IsURL: "false",
                IsFullURL: "false",
                ToReplace: "",
                PrepareTextForQS: "false",
              },
            },
            this.textArray[index].query,
          ],
        });
      }
      // for loop to create the queries of remove in the xml
      for (var index = 0; index < this.removeArray.length; index++) {
        xml2[0].Configuration[3].ToRemove.push({
          Item: [
            {
              _attr: {
                ForURLsId: "",
                Reference: this.removeArray[index].reference,
              },
            },
            {
              Queries: [
                {
                  Query: [
                    {
                      _attr: {
                        Id: index + 1,
                        ConfidenceLevel: 0,
                        IsURL: "false",
                        IsFullURL: "false",
                        ToReplace: "",
                        PrepareTextForQS: "false",
                      },
                    },
                    this.removeArray[index].query,
                  ],
                },
              ],
            },
          ],
        });
      }

      this.SourceRss.c_u_Parameters2 = xml(xml2, {
        declaration: { version: "1.0", encoding: "UTF-8", standalone: "no" },
      });
    },
    async createUrlSouce(evt) {
      if (this.isSimple) {
        // create the xml for the source
        const xml = require("xml");
        let indexUrls = [];
        let queryIndex = 1;
        //structure for the parameters1 xml
        let xml1 = [
          {
            Configuration: [
              { _attr: { for: "List" } },
              { URLs: [] },
              { ToExtract: [] },
              { ToRemove: "" },
            ],
          },
        ];
        // for loop to create the url queries in the xml
        for (var index = 0; index < this.urlArray.length; index++) {
          xml1[0].Configuration[1].URLs.push({
            URL: [
              {
                _attr: {
                  Id: index + 1,
                  Priority: this.urlArray[index].priority,
                },
              },
              this.urlArray[index].url,
            ],
          });
          indexUrls[index] = index + 1;
        }
        xml1[0].Configuration[2].ToExtract.push({
          Item: [
            { _attr: { ForURLsID: indexUrls.join(",") } },
            {
              Queries: [
                {
                  Query: [
                    {
                      _attr: {
                        Id: queryIndex,
                        ConfidenceLevel: "0",
                        IsURL: "true",
                        IsFullURL: "true",
                        ToReplace: "",
                        PrepareTextForQS: "false",
                      },
                    },
                    this.urlParameters1 + "/@href",
                  ],
                },
                {
                  URL: "",
                },
              ],
            },
          ],
        });

        this.SourceRss.c_u_Parameters1 = xml(xml1, {
          declaration: { version: "1.0", encoding: "UTF-8", standalone: "no" },
        });
      } else {
        this.SourceRss.c_u_Parameters1 = this.advancedXML;
      }

      await this.$api.data.create(this.SourceRss);

      this.$emit("ok");

      //remove the values from the modal
      this.referenceSource = "";

      this.urlArray = [
        {
          url: "",
          priority: 0,
        },
      ];
      this.clicked = 1;
      this.isSimple = true;
      this.urlParameters1 = "";
    },
    addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },

    addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0,
      };
    },

    addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = { query: "", confidenceLevel: 0 };
    },

    addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv(evt) {
      this.clicked++;
      this.urlArray[this.clicked - 1] = { url: "", priority: 0 };
    },
    addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = { reference: 0, query: "" };
    },

    advancedMode(evt) {
      if (this.isSimple == true) {
        this.advancedXML =
          '<?xml version="1.0" encoding="utf-8" standalone="no"?>' + "\n";
        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        document.getElementsByClassName("advance")[0].innerText =
          "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.advancedXML2 =
          '<?xml version="1.0" encoding="utf-8" standalone="no"?>' + "\n";
        document.getElementsByClassName("advance2")[0].innerText =
          "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText =
          "Advanced Mode";
        this.isSimple2 = true;
      }
    },
  },
  mounted: function () {},
};
</script>


// WEBPACK FOOTER //
// src/components/Sources/rss/CreateRss.vue